<template>
  <div class="price-board mb-3" dir="rtl">
    <div class="board-head mb-2">
      <div class="d-flex align-items-center justify-content-between flex-wrap">
        <div>
          <h6 class="mb-1">فرمول قیمت</h6>
          <p class="mb-0 text-muted small">
            قیمت پایه را روی خود گزینه بنویس (مثلا پراید = ۸۹۴۴۰۰۰۰). توکن سؤال در فرمول همان قیمت گزینه انتخاب‌شده است، نه متن گزینه.
            بعد با شرط ضریب بزن: تاکسی شهری × ۱.۱ ، سواری شخصی بدون ضریب، سنگین از سؤال بارکش.
          </p>
        </div>
        <b-form-checkbox v-model="price.enabled" switch size="sm">فعال</b-form-checkbox>
      </div>
    </div>

    <div v-if="price.enabled">
      <div class="price-card mb-2">
        <strong class="d-block mb-2">فرمول پیش‌فرض</strong>
        <p class="text-muted small mb-2">اگر هیچ شرط قیمتی برقرار نبود، این محاسبه نشان داده می‌شود. مثال سواری: فقط توکن مدل خودرو.</p>
        <form-formula-field :value="price.default_formula" :questions="questions" @input="setDefault"/>
        <button type="button" class="btn btn-sm btn-outline-primary mt-2" @click="fillThirdPartyExample">
          ساخت فرمول بیمه شخص ثالث از روی همین فرم
        </button>
      </div>

      <div v-for="(rule, index) in price.rules" :key="rule.id || index" class="price-card mb-2">
        <div class="d-flex align-items-center justify-content-between mb-2">
          <input
            type="text"
            class="form-control form-control-sm rule-title"
            v-model="rule.title"
            placeholder="مثلا قیمت موتورسیکلت"
          >
          <button type="button" class="btn btn-sm btn-outline-danger" @click="removeRule(index)">حذف</button>
        </div>

        <p class="small mb-2">اگر این شرط برقرار بود، این فرمول قیمت اعمال شود:</p>
        <form-path-rule-editor
          :rule="rule"
          :step-questions="[]"
          :other-questions="conditionQuestions"
          :other-steps="[]"
          :all-questions="questions"
          hide-target
        />

        <div class="mt-2">
          <label class="small mb-1">محاسبه قیمت</label>
          <form-formula-field v-model="rule.formula" :questions="questions"/>
        </div>
      </div>

      <button type="button" class="btn btn-sm btn-primary" @click="addRule">
        + فرمول شرطی
      </button>
    </div>
  </div>
</template>

<script>
import FormPathRuleEditor from "./FormPathRuleEditor.vue";
import FormFormulaField from "./FormFormulaField.vue";
import {applySuggestedOptionPrices, buildThirdPartyPriceRules, ensurePriceConfig, visibleFormItems} from "../formQuestionContext";

export default {
  name: "FormPriceFormulas",
  components: {FormPathRuleEditor, FormFormulaField},
  props: {
    formQuestionsRoot: {
      type: Object,
      required: true
    }
  },
  computed: {
    questions() {
      return visibleFormItems(this.formQuestionsRoot.form)
    },
    price() {
      return ensurePriceConfig(this.formQuestionsRoot)
    },
    conditionQuestions() {
      return this.questions.filter(item => item.type !== 'step')
    }
  },
  methods: {
    setDefault(value) {
      this.$set(this.price, 'default_formula', value)
    },
    fillThirdPartyExample() {
      applySuggestedOptionPrices(this.formQuestionsRoot.form)
      const built = buildThirdPartyPriceRules(this.formQuestionsRoot.form)
      this.$set(this.price, 'enabled', true)
      this.$set(this.price, 'value_source', 'option_price')
      this.$set(this.price, 'default_formula', built.default_formula)
      this.$set(this.price, 'rules', built.rules)
      this.$forceUpdate()
    },
    addRule() {
      this.price.rules.push({
        id: `price_${Date.now()}`,
        title: '',
        formula: '',
        when: {all: [{question_id: '', step_id: '', variable: '', op: 'eq', value: ''}]}
      })
    },
    removeRule(index) {
      this.price.rules.splice(index, 1)
    }
  }
}
</script>

<style scoped>
.price-board {
  background: #f4f7f6;
  border: 1px solid #d7e5e2;
  border-radius: 12px;
  padding: 10px;
}

.price-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 12px;
}

.rule-title {
  max-width: 280px;
}
</style>
